import React, { useState, useEffect, useCallback } from "react";
import { API_BASE_URL } from "../config";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { onValue, ref } from "firebase/database";
import { database } from "../firebase/firebaseConfig";
import Swal from "sweetalert2";
import { useLoading } from "../contexts/LoadingContext";
import Loader from "./loader";
import "./doctor-list-component.css";

const DoctorListComponent = () => {
  const [doctors, setDoctors] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const { isLoading, setIsLoading } = useLoading();
  const navigate = useNavigate();

  const session = JSON.parse(sessionStorage.getItem("user"));

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}/doctor/list?page=1&perPage=30`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        if (data.statusCode === 1 && Array.isArray(data.payLoad)) {
          const formattedDoctors = data.payLoad.map((doctor) => ({
            applicationUserId: doctor.ApplicationUserId,
            email: doctor.Email,
            name: `${doctor.FirstName}`,
            specialty: doctor.DoctorSpecialties,
            imgLink: doctor.ImgLink,
            averageRating: doctor.AverageRating,
            doctorDutyTime: doctor.DoctorDutyTime,
            onlineStatus: doctor.OnlineStatus,
            onlineDoctor: doctor.OnlineDoctor,
            status: doctor.OnlineDoctor === 1 ? "online" : "offline",
          }));
          setDoctors(formattedDoctors);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [setIsLoading]);

  useEffect(() => {
    const realtimeRef = ref(database, "Doctors");
    const unsubscribe = onValue(realtimeRef, (snapshot) => {
      const realtimeData = snapshot.val();
      if (realtimeData) {
        const updatedDoctors = doctors.map((doctor) => {
          const email = doctor.email.replace(/\./g, "");
          const status = realtimeData[email]?.status || doctor.onlineStatus;
          return { ...doctor, status };
        });
        setDoctors(updatedDoctors);
      }
    });

    return () => {
      unsubscribe();
    };
  }, [doctors]);
  const onAudioVideoCallClick = useCallback(
    (appointment, email, doctorId) => {
      if (!session?.payLoad.access_token) {
        Swal.fire({
          icon: "info",
          title: "Login",
          text: "Please login first",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        }).then(() => {
          navigate(`/login/doctors-list`);
          return;
        });
      } else {
        if (!session?.payLoad.user.userPackages || session.payLoad.user.userPackages.length === 0) {
          navigate("/packages");
        } else {
          if (email) {
            var fromCall = 'fromInstant';
            navigate(`/video-call`, {
              state: { appointment, email, doctorId, fromCall },
            });
          } else {
            console.error("Doctor profile data is not available.");
          }
        }
      }
    },
    [navigate, session]
  );

  const onDoctorProfile = useCallback(
    (id, email, status) => {
      sessionStorage.setItem("doctorEmail", email);
      sessionStorage.setItem("doctorStatus", status);
      navigate(`/doctor-profile/${id}`);
    },
    [navigate]
  );

  const handleSearchInputChange = useCallback((event) => {
    setSearchKeyword(event.target.value);
  }, []);

  const filteredDoctors = doctors.filter(
    (doctor) =>
      doctor.name.toLowerCase().includes(searchKeyword.toLowerCase()) ||
      (doctor.specialty &&
        doctor.specialty.toLowerCase().includes(searchKeyword.toLowerCase()))
  );

  const onlineDoctors = filteredDoctors.filter(
    (doctor) => doctor.status === "online"
  );
  const busyDoctors = filteredDoctors.filter(
    (doctor) => doctor.status === "busy"
  );
  const offlineDoctors = filteredDoctors.filter(
    (doctor) => doctor.status === "offline"
  );

  const doctorListToRender = onlineDoctors.concat(busyDoctors, offlineDoctors);

  return (
    <div className="d-flex flex-column align-items-center">
      {isLoading ? (
        <Loader type="doctor" count={9} />
      ) : (
        <div style={{ marginBottom: "100px", padding: "0 50px" }}>
          <div className="mb-2">
            <input
              type="text"
              placeholder="Search.."
              className="search-bar"
              value={searchKeyword}
              onChange={handleSearchInputChange}
            />
          </div>

          <Row>
            {doctorListToRender.map((doctor) => (
              <Col key={doctor.applicationUserId} sm={12} lg={6} md={6}>
                <Card className="doctorlist-card">
                  <Card.Body>
                    <Row>
                      <Col
                        md={12}
                        xs={12}
                        lg={4}
                        className="d-flex align-items-center justify-content-center"
                      >
                        <div className="ellipse2">
                          <div>
                            <img
                              className="d2-parent2"
                              alt=""
                              src={doctor.imgLink}
                            />
                            <div
                              className={`${
                                doctor.status === "online"
                                  ? "star-field"
                                  : doctor.status === "busy"
                                  ? "busy-star-field"
                                  : "offline-star-field"
                              }`}
                            />
                            {/* <div
                              className={`badge text-light ms-2 ${
                                doctor.status === "online"
                                  ? "bg-success"
                                  : doctor.status === "busy"
                                  ? "bg-warning"
                                  : "bg-secondary"
                              }`}
                            >
                              {doctor.status.toUpperCase()}
                            </div> */}
                          </div>
                        </div>
                      </Col>

                      <Col md={12} xs={12} lg={8} className="">
                        <div>
                          <div className="">
                            <span className="doctor-name">{doctor.name}</span>
                            <br />
                            <span className="doctor-specialty">
                              {doctor.specialty || "N/A"}
                            </span>
                            <br />
                            <span className="doctor-duty-time">
                              ({doctor.doctorDutyTime})
                            </span>
                            <div className="mb-2">
                              {[...Array(Math.round(doctor.averageRating))].map(
                                (_, index) => (
                                  <img
                                    key={index}
                                    src="/star-component.svg"
                                    alt="Star rating"
                                    className="me-1"
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                )
                              )}
                            </div>
                          </div>
                        </div>
                        <Button
                          style={{
                            width: "50px;",
                            backgroundColor: "#50C4CC",
                            textColor: "#fff",
                          }}
                          variant="outline-info"
                          className="call-button-doctorlist d-flex align-items-center justify-content-center gap-2 mb-2"
                          onClick={() => {
                            if (doctor.status !== "online") {
                              Swal.fire({
                                icon: "info",
                                title: "Please wait",
                                text: "Please wait for the doctor to come online.",
                                confirmButtonText: "OK",
                                allowOutsideClick: false,
                              }).then(() => {
                                navigate(`/`);
                              });
                            } else {
                              onAudioVideoCallClick(
                                1,
                                doctor.email,
                                doctor.applicationUserId
                              );
                            }
                          }}
                        >
                          <img
                            src="/Vector-16.png"
                            style={{ width: "18px", height: "14px" }}
                          />
                          Video
                        </Button>
                        <Button
                          style={{ width: "50px;" }}
                          variant="outline-info"
                          className="profile-button-doctorlist mb-1 d-flex align-items-center justify-content-center gap-2"
                          onClick={() =>
                            onDoctorProfile(
                              doctor.applicationUserId,
                              doctor.email,
                              doctor.status
                            )
                          }
                        >
                          <img
                            src="/user.png"
                            style={{ width: "18px", height: "18px" }}
                          />
                          Profile
                        </Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      )}
    </div>
  );
};

export default DoctorListComponent;
